import {Component, EventEmitter, Input, Output} from '@angular/core'
import {HomePageContent} from '../../../../core/content/types/home-page.types'

@Component({
  selector: 'bgo-home-page-content',
  templateUrl: './home-page-content.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class HomePageContentComponent {
  @Input() content!: HomePageContent[]

  @Output() howItWorksCtaClicked = new EventEmitter()
  @Output() reviewCtaClicked = new EventEmitter()
}
